import { useNavigate } from 'react-router-dom'
import { Button } from '../../components'
import './HomePage.css'

export function HomePage() {
  const navigate = useNavigate()

  return (
    <div className=" home-page flex-1 flex  w-full h-full justify-center items-center">
      <div className="hero-section w-30">
        <h1>3D模型预览</h1>
        <Button
          size='lg'
          onClick={() => navigate('/custom-deck-cover')}
        >
          查看模型
        </Button>
      </div>
    </div>
  )
}